"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PROMO_BANNER_VIDEO = exports.PROMO_BANNER_TITLE = exports.PROMO_BANNER_IMAGE = exports.PROMO_BANNER_FAKE_LINK = exports.PROMO_BANNER = void 0;
// Test IDs
const PROMO_BANNER = exports.PROMO_BANNER = 'PromoBanner';
const PROMO_BANNER_TITLE = exports.PROMO_BANNER_TITLE = 'PromoBannerTitle';
const PROMO_BANNER_FAKE_LINK = exports.PROMO_BANNER_FAKE_LINK = 'PromoBannerFakeLink';
const PROMO_BANNER_IMAGE = exports.PROMO_BANNER_IMAGE = 'PromoBannerImage';
const PROMO_BANNER_VIDEO = exports.PROMO_BANNER_VIDEO = 'PromoBannerVideo';
